import { render, staticRenderFns } from "./LoadingArea.vue?vue&type=template&id=9d852936&scoped=true"
import script from "./LoadingArea.vue?vue&type=script&lang=js"
export * from "./LoadingArea.vue?vue&type=script&lang=js"
import style0 from "./LoadingArea.vue?vue&type=style&index=0&id=9d852936&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d852936",
  null
  
)

export default component.exports